import './Portfolio.css';
import corporateImage from '../../assets/corporate.jpg';
import showsImage from '../../assets/shows.jpg';
import socialImage from '../../assets/social.jpg';


const PortfolioCard = ({ image, category, title, description, index }) => (
  <div className="portfolio-card" data-aos="fade-up" data-aos-delay={index * 100}>
    <div className="portfolio-image">
      <img src={image} alt={title} />
    </div>
    <div className="portfolio-info">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

const Portfolio = () => {
    const projects = [
        {
          image: corporateImage,
          category: "Eventos Corporativos",
          title: "Eventos Corporativos",
          description: "Implementamos soluções de iluminação e displays de LED para eventos corporativos de grande porte..."
        },
        {
          image: showsImage,
          category: "Shows e Festivais",
          title: "Shows e Festivais",
          description: "Crie um ambiente vibrante e imersivo para o seu festival musical..."
        },
        {
          image: socialImage,
          category: "Casamentos e Eventos Sociais",
          title: "Casamentos e Eventos Sociais",
          description: "Personalize sua festa de casamento ou evento social..."
        }
      ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="section-title" data-aos="fade-up">
        <h2>Portfólio: Projetos Recentes e Clientes Satisfeitos</h2>
      </div>
      <div className="portfolio-grid">
        {projects.map((project, index) => (
          <PortfolioCard key={index} {...project} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio; 
